//
// GeoEnrichmentResult.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../moduleBuilder";
import EventDispatcher from "../events/EventDispatcher";
import "../lib";

var GeoEnrichmentResult = createModule("commons::GeoEnrichmentResult", [], EventDispatcher, [
    ,
    ,
    ,
    {
        decimals: 4,
        name: 7,
        alias: 7,
        fullName: 7,
        currency: 7,
        units: 7,
        type: 7,
        value: 7,
    },
    {
        getFormattedValue: [7],
    },
    {
        _create: [4],
    },
    ,
]);
export default GeoEnrichmentResult;
